import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link, IndexLink } from 'react-router';
import { Tag } from '@zola/zola-ui';

import DropdownNavItem from './DropdownNavItem';
import featureFlags from '../../../../util/featureFlags';

export default class SecondaryNavItem extends Component {
  constructor(props) {
    super(props);
    this.handleMouseHover = this.handleMouseHover.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
    this.handleMouseClick = this.handleMouseClick.bind(this);
    this.hideNavItem = this.hideNavItem.bind(this);
    this.handleDropdownItemMouseClick = this.handleDropdownItemMouseClick.bind(this);
    this.state = {
      isHovering: false,
    };
  }

  handleMouseHover() {
    this.setState({ isHovering: true });
  }

  handleMouseOut() {
    this.setState({ isHovering: false });
  }

  handleMouseClick() {
    this.setState({ isHovering: false });
  }

  handleDropdownItemMouseClick(e) {
    this.setState({ isHovering: false });
    e.stopPropagation();
    window.dispatchEvent(
      new CustomEvent('WEB_WEDDING_SECONDARY_NAV_CLICK', {
        detail: { node: e.target, section: 'SECONDARY_SUB_MENU', destination_url: e.target.href },
      })
    );
  }

  hideNavItem(navItem) {
    const { userContext } = this.props;
    return navItem.showFn && !navItem.showFn(userContext);
  }

  render() {
    const { navItem, idx, altActive, editActive, altActiveGlobal, guestRequestCount, activeCardEvent } = this.props;
    const mainNavHasChildren = Array.isArray(navItem);
    const mainNavItem = mainNavHasChildren ? navItem[0] : navItem;
    const navItemChildren = mainNavHasChildren ? navItem[1] : null;
    const navItemDropdownClassNames = classNames('dropdown', {
      'dropdown--active': this.state.isHovering,
    });
    const shouldApplyHolidayTreatment = featureFlags.get('holidayNav') && mainNavItem.navText === 'Holiday Cards';
    const navItemClassNames = classNames({
      active: (mainNavItem.navText === 'Edit Pages' && editActive)
        || (mainNavItem.navText === 'View Designs' && altActive)
        || (mainNavItem.navText === 'Website' && altActive)
        || (mainNavItem.navText === 'Track RSVPs' && altActiveGlobal)
        || (mainNavItem.navText === 'Your Orders + Drafts' && altActive)
        || (mainNavItem.navText === 'Save The Dates' && activeCardEvent === 'SAVE_THE_DATE')
        || (mainNavItem.navText === 'Change The Dates' && activeCardEvent === 'CHANGE_THE_DATE')
        || (mainNavItem.navText === 'Invitations' && activeCardEvent === 'INVITATION')
        || (mainNavItem.navText === 'Enclosure Cards' && activeCardEvent === 'DETAILS')
        || (mainNavItem.navText === 'Menus' && activeCardEvent === 'MENU')
        || (mainNavItem.navText === 'Programs' && activeCardEvent === 'PROGRAM')
        || (mainNavItem.navText === 'Place Cards' && activeCardEvent === 'PLACE_CARDS')
        || (mainNavItem.navText === 'Thank You Cards' && activeCardEvent === 'THANK_YOU')
        || (mainNavItem.navText === 'Holiday Cards' && activeCardEvent === 'HOLIDAY'),
      dropdown__trigger: mainNavHasChildren,
      'holiday-sub-nav-item': shouldApplyHolidayTreatment,
    });
    if (this.hideNavItem(mainNavItem)) {
      return null;
    }
    return mainNavHasChildren ? (
      <li
        key={idx}
        onMouseEnter={this.handleMouseHover}
        onMouseLeave={this.handleMouseOut}
        className={navItemDropdownClassNames}
      >
        {mainNavItem.notReactLink ? (
          <a
            href={mainNavItem.navUrl}
            className={navItemClassNames}
            onClick={this.handleMouseClick}
          >
            {mainNavItem.navText} <i className="caret" />
          </a>
        ) : (
          <Link
            to={mainNavItem.navUrl}
            href={mainNavItem.navUrl}
            activeClassName="active"
            className={navItemClassNames}
            onClick={this.handleMouseClick}
          >
            {mainNavItem.navText} <i className="caret" />
            {guestRequestCount !== 0 && navItem[0].receivesNotifications && (
              <span className="top-level-badge" />
            )}
          </Link>
        )}
        <div className="dropdown__content">
          <ul className="dropdown-menu dropdown-menu-left">
            {navItemChildren.map((childNavItem, childIdx) => (this.hideNavItem(childNavItem) ? null : (
              <DropdownNavItem
                key={childIdx}
                handleMouseClick={this.handleDropdownItemMouseClick}
                {...childNavItem}
                guestRequestCount={guestRequestCount}
              />
            )))}
          </ul>
        </div>
      </li>
    ) : (
      // Nav Item without children
      <li key={idx}>
        {mainNavItem.notReactLink ? (
          <a
            href={mainNavItem.navUrl}
            className={navItemClassNames}
            onClick={this.handleMouseClick}
          >
            {mainNavItem.navText}
          </a>
        ) : (
          <IndexLink
            key={idx}
            onlyActiveOnIndex
            to={
              mainNavItem.navUrl === '/wedding-planning/projects'
                ? '/wedding-planning/projects/drafts'
                : mainNavItem.navUrl
            }
            activeClassName="active"
            className={navItemClassNames}
          >
            {mainNavItem.navText}
            {mainNavItem.receivesNotifications && guestRequestCount !== 0 && (
              <span className="mobile-badge" />
            )}
            {shouldApplyHolidayTreatment && <span className="zola-ui-icon-gift" />}
            {mainNavItem.newTag && (
              <Tag size="sm" primary className="inline-tag">NEW</Tag>
            )}
          </IndexLink>
        )}
      </li>
    );
  }
}

SecondaryNavItem.propTypes = {
  navItem: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))])
    )
  ]),
  idx: PropTypes.number,
  altActive: PropTypes.bool,
  editActive: PropTypes.bool,
  altActiveGlobal: PropTypes.bool,
  guestRequestCount: PropTypes.number,
  userContext: PropTypes.shape({}),
  activeCardEvent: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/common/header/SecondaryNav/SecondaryNavItem.jsx